import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MFA_OAUTH_URL,
  MULTI_FACTOR_EndpointKey
} from '../../../../constants/multi-factor-authentication/multi-factor-authentication-constant';
import { FlyDeltaPoll } from '../../../../models/multi-factor-authentication';
import { HttpHeadersPayload, ReplaceItem } from '../../../../models/utils';
import { ApiBuilder, AppConfigService, handleError } from '../../../utils';
import { LoginRememberMeUtilsService } from '../../../../utils/login';
import { OauthAEMConfig } from '../../../../models/login';
import { HttpRequestMethods, IDP_APP } from '../../../../constants/utils';

@Injectable({
  providedIn: 'root'
})
export class FlyDeltaPollService {
  flyDetlaPollHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.poll+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: LoginRememberMeUtilsService
  ) {}

  submitFlyDeltaPoll = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<FlyDeltaPoll> => {
    const flyDeltaPollUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitFlyDeltaPollMfaUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: flyDeltaPollUrl
      }
    ];

    return new ApiBuilder<undefined, FlyDeltaPoll>(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(MULTI_FACTOR_EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitFlyDeltaPollMfaUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.flyDetlaPollHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_FLY_DELTA_POLL_SERVICE')
      .withCredentials(true)
      .create();
  };
}
